module.exports = __webpack_public_path__ + "static/media/rw.32931738.svg";